export default {
  methods: {
    trainingStatusFields() {
      return [
        {
          key: 'course',
          label: 'Course',
          sortable: true,
          thStyle: { width: '38%' },
        },
        {
          key: 'role',
          label: 'Role',
          sortable: true,
        },
        {
          key: 'assigned_date',
          label: 'Assigned Date',
          sortable: true,
        },
        {
          key: 'due_date',
          label: 'Due Date',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
        },
      ];
    },
    systemAccessFields() {
      return [
        {
          key: 'system',
          label: 'System',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Access Status',
          sortable: true,
          thStyle: { width: '20%' },
        },
        {
          key: 'requests',
          label: '',
          thStyle: { width: '35%' },
        },
      ];
    },
    sitesFields() {
      return [
        {
          key: 'studyInfo.studyID',
          label: 'Study ID',
          sortable: true,
        },
        {
          key: 'siteInfo.siteNumber',
          label: 'Site Number',
          sortable: true,
        },
        {
          key: 'siteInfo.enrollmentStatus',
          label: 'Enrollment Status',
          sortable: true,
        },
        {
          key: 'siteInfo.countryName',
          label: 'Country',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Actions',
        },
      ];
    },
    studySitesFields() {
      return [
        {
          key: 'details',
          label: 'Details',
        },
        {
          key: 'site',
          label: 'Study - Site',
        },
        {
          key: 'siteEnrollmentData.randomized',
          label: 'Randomized',
          sortable: true,
        },
        {
          key: 'siteInfo.simplifySiteStatus',
          label: 'Site Status',
          sortable: true,
        },
        {
          key: 'siteInfo.investigatorName',
          label: 'PI Name',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Action',
        },
      ];
    },
    studiesFields() {
      return [
        {
          key: 'studyID',
          label: 'Study ID',
          sortable: true,
        },
        {
          key: 'therapeyticArea',
          label: 'Therapeutic Area',
          sortable: true,
        },
        {
          key: 'studyStatus',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'drugProgram',
          label: 'Drug Program',
          sortable: true,
        },
        {
          key: 'developmentPhase',
          label: 'Development Phase',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Actions',
        },
      ];
    },
    eventsFields() {
      return [
        {
          key: 'Event_Name__c',
          label: 'Survey Name',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Actions',
        },
      ];
    },
    getPersonFields() {
      return [
        {
          key: 'actions',
          label: 'Actions',
        },
        {
          key: 'Name',
          label: 'PERSON',
          sortable: true,
        },
      ];
    },
    getPersonSurveysFields() {
      return [
        {
          key: 'surveyStatus',
          label: 'Survey Status',
          sortable: true,
        },
        {
          key: 'surveyLastModifiedDate',
          label: 'Survey Last Modified Date',
          sortable: true,
        },
        {
          key: 'surveyCompletedBy',
          label: 'Survey Complete By',
        },
        {
          key: 'action',
          label: 'Action',
        },
      ];
    },
    myTeam() {
      return [
        {
          key: 'firstName',
          label: 'First Name',
          sortable: true,
        },
        {
          key: 'lastName',
          label: 'Last Name',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Actions',
        },
      ];
    },
    myAccess() {
      return [
        {
          key: 'requestType',
          label: 'Request Type',
          sortable: true,
        },
        {
          key: 'application',
          label: 'Application',
        },
        {
          key: 'systemRole',
          label: 'Application Role',
        },
        {
          key: 'statusMap',
          label: 'Request Status',
          sortable: true,
        },
        {
          key: 'accountStatus',
          label: 'Account Status',
          sortable: true,
        },
        {
          key: 'lastUpdated',
          label: 'Last Updated',
          sortable: true,
        },
      ];
    },
    mobileFields() {
      return [
        {
          key: 'application',
          label: 'Application',
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'details',
          label: 'Details',
        },
      ];
    },
    accessRequestDashboard() {
      return [
        {
          key: 'childId',
          label: 'Request ID',
        },
        {
          key: 'on_behalf_of_user',
          label: 'Requested For',
          sortable: true,
        },
        {
          key: 'requestor',
          label: 'Requested By',
        },
        {
          key: 'requestType',
          label: 'Request Type',
          sortable: true,
        },
        {
          key: 'application',
          label: 'Application',
          sortable: true,
        },
        {
          key: 'systemRole',
          label: 'Application Role',
          sortable: true,
        },
        {
          key: 'statusMap',
          label: 'Request Status',
          sortable: true,
        },
        {
          key: 'accountStatus',
          label: 'Account Status',
          sortable: true,
        },
        {
          key: 'lastUpdated',
          label: 'Last Updated',
          sortable: true,
        },
      ];
    },
  },
};
